import React, { useEffect, useState } from 'react';
import { useController } from './controller';
import * as S from './styles';
import { translations } from './translation';

const ImprovedLoading = (props: { active: boolean, showName?: false, curiosities: string[], loadMoreTips: () => any }) => {
    const controller = useController(props);

    return controller.activeLoading || (props.active && props.active == true) ? (
        <S.main>
            <S.curiositiesArea>
                <S.curiositiesTitle>
                    {props.curiosities.length > 5 ? translations[controller.currentLanguage].curiosities : translations[controller.currentLanguage].tips}:
                </S.curiositiesTitle>
                <S.curiosities>
                    {((props.curiosities?.length > 5 ? props.curiosities?.slice(-5) : props.curiosities) ?? []).map((item, index) => (
                        <S.curiosity>{item}</S.curiosity>
                    ))}
                </S.curiosities>
            </S.curiositiesArea>

            <S.loadingContainer>
                <S.loadingContainerIcons>
                    <S.loadingContainerIconsArea>
                        {props.active ? (
                            <S.loadingContainerIcon index={0} direction={'right'} icon={controller.general.icons.faGear} />
                        ) : (
                            <S.containerIconNoAnim icon={controller.general.icons.faCircleCheck} onClick={() => {
                                if (!props.active) {
                                    controller.setActiveLoading(false);
                                    props.loadMoreTips()
                                }
                            }} />
                        )}
                    </S.loadingContainerIconsArea>
                </S.loadingContainerIcons>
                <S.loadingContainerText continueActive={!props.active} onClick={() => {
                    if (!props.active) {
                        controller.setActiveLoading(false);
                        props.loadMoreTips()
                    }
                }}>
                    {props.active ? `${translations[controller.currentLanguage].loading}...` : translations[controller.currentLanguage].continue}
                </S.loadingContainerText>
            </S.loadingContainer>
        </S.main >
    ) : null;
}

export default ImprovedLoading;